import * as zExt from "@redotech/rpc/ext";
import * as z from "zod";

export const updateReturnAdjustment = {
  name: "updateReturnAdjustment" as const,
  input: z.object({ returnId: zExt.objectId(), newReturnValue: z.number() }),
  output: z.object({ success: z.boolean() }),
};
